import { render, staticRenderFns } from "./GJgrowEventCreateTermExamAtAfter.vue?vue&type=template&id=e3de51a0&scoped=true&"
import script from "./GJgrowEventCreateTermExamAtAfter.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateTermExamAtAfter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3de51a0",
  null
  
)

export default component.exports